<template>
  <div class="article">
    <div class="search-article">
      <div class="search-bar">
        <icon icon-class="search"></icon><input type="text" class="search-input" v-model="searchKey" placeholder="搜索" @keyup.enter="searchArticle">
        <span class="clear-search" @click="searchArticle('clear')"><icon icon-class="close"></icon></span>
      </div>
      <div class="filter-box">
        <div class="filter-item" v-for="item in filters" :class="{'active': currentFilter == item.id}" @click="filterArticle(item)">{{item.value}}</div>
      </div>
    </div>
    <div class="article-list" v-if="articleList.length > 0">
      <div class="article-item" v-for="item in articleList" :key="item.id" @click="toArticleDetail(item)">
        <div class="info">
          <div class="label"><span class="type" :class="['type-' + item.type]">{{item.type | articleType}}</span></div>
          <div class="title">{{item.title}}</div>
          <div class="keyword" v-if="item.type != 10">关键词：{{item.keywords}}</div>
        </div>
        <div class="cover lazy-load"><img :src="item.thumb" alt=""></div>
      </div>
      <div class="load-more">
        <div class="no-more" v-if="noMoreArticle">- 没有更多了喔 -</div>
        <div v-else><icon icon-class="loading" class="loading"></icon><span>正在加载更多</span></div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .article{
    min-height: 100vh;
    background: #F8F8F8;
    .search-article{
      padding: 24px 12px 12px;
      .search-bar{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #FFF;
        padding: 0 12px;
        box-shadow: 0px 2px 8px 0px rgba(77, 162, 199, 0.05);
        height: 36px;
        font-size: 14px;
        color: #999;
        border-radius: 36px;
        svg{
          position: relative;
          top: 1px;
          font-size: 24px;
          color: #CACACA;
          margin-right: 4px;
        }
        .search-input{
          flex: 1;
          border: 0;
          font-size: 14px;
          color: #666;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .clear-search{
          svg{
            font-size: 14px;
          }
        }
      }
      .filter-box{
        overflow: auto;
        white-space: nowrap;
        margin-top: 32px;
        .filter-item{
          position: relative;
          display: inline-block;
          font-size: 14px;
          line-height: 14px;
          color: #666;
          margin-right: 16px;
          padding-bottom: 11px;
          &:last-child{
            margin-right: 0;
          }
          &.active{
            font-weight: bold;
            color: #333;
            &::after{
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 3px;
              border-radius: 3px;
              background: @cano;
            }
          }
        }
      }
    }
    .article-list{
      .article-item{
        margin-bottom: 8px;
        padding: 16px 12px;
        background: #FFF;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .info{
          padding-right: 12px;
          min-width: 0;
          .label{
            display: flex;
            align-items: center;
            font-size: 13px;
            line-height: 13px;
            color: #999;
            .type{
              position: relative;
              padding-left: 17px;
              font-size: 13px;
              line-height: 13px;
              color: #666;
              margin-right: 8px;
              &::after{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 13px;
                height: 13px;
                border-radius: 50%;
                background: #CCC;
                z-index: 2;
              }
              &::before{
                content: '';
                position: absolute;
                left: 4px;
                top: 4px;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #FFF;
                opacity: .6;
                z-index: 3;
              }
              &.type-1::after{
                background: #53BE19;
              }
              &.type-2::after{
                background: #6C4BC9;
              }
              &.type-4::after{
                background: #DC42E2;
              }
              &.type-5::after{
                background: #F64865;
              }
              &.type-6::after{
                background: #FAA12D;
              }
              &.type-7::after{
                background: #25C0C2;
              }
              &.type-8::after{
                background: #FFA2DA;
              }
              &.type-9::after{
                background: #0091FF;
              }
            }
          }
          .title{
            margin-top: 8px;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            color: #333;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
          }
          .keyword{
            margin-top: 8px;
            font-size: 12px;
            line-height: 14px;
            color: #666;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .cover{
          flex-shrink: 0;
          width: 114px;
          height: 84px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          img{
            width: 100%;
          }
        }
      }
      .load-more {
        height: 60px;
        width: 100%;
        line-height: 60px;
        text-align: center;
        font-size: 14px;
      }

      .load-more span {
        color: #4A4A4A;
      }
      .load-more svg{
        font-size: 14px;
      }
      .load-more .no-more{
        color: #888888;
      }

      @keyframes loading {
        0% {transform: rotate(0deg)}
        50% {transform: rotate(180deg)}
        100% {transform: rotate(360deg)}
      }

      .loading {
        display: inline-block;
        transform-origin: 50% 50%;
        position: relative;
        left: -3px;
        top: -1px;
        animation: loading 1s linear infinite;
      }
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        filters: [{
          id: 0,
          value: '全部',
        },{
          id: 1,
          value: '在路上',
        },{
          id: 2,
          value: '经验弹',
        },{
          id: 4,
          value: '话局',
        },{
          id: 5,
          value: '设计室',
        },{
          id: 7,
          value: '名校记',
        },{
          id: 8,
          value: '奇想集',
        },{
          id: 9,
          value: '交互设计',
        },{
          id: 6,
          value: '资讯',
        },{
          id: 10,
          value: '公开课',
        }],
        currentFilter: 0,
        searchKey: '',
        loadingMoreData: false,
        page: 0,
        noMoreArticle: false,
        articleList: [],
      }
    },
    created() {
      this.$store.commit('setActiveMenu', 'article')
      this.getArticle(this.page, () => {
        this.$nextTick(() => {
          $(window).on('scroll',this.scrollHandler);
        })
      });
    },
    beforeDestroy() {
      $(window).off('scroll',this.scrollHandler);
    },
    methods: {
      scrollHandler() {
        let scrollTop = $(document).scrollTop();
        let windowHeight = $(window).height();
        let documentHeight = $(document).height() - 20;
        console.log(this.noMoreArticle, this.loadingMoreData)
        // 触底加载更多
        if(scrollTop + windowHeight >= documentHeight && !this.noMoreArticle && !this.loadingMoreData) {
          this.page = this.page + 1;
          this.getArticle(this.page, null, true);
        }
      },
      getArticle(page, cb, more = false) {
        if(more) this.loadingMoreData = true;
        this.$root.post('/Article/get_article_list', {
          type: this.currentFilter,
          page: page ? page : 0,
          count: 16,
          order: 1,
          search: this.searchKey,
        }).then(data => {
          console.log(data);
          // 设置已无加载内容状态
          if (data.is_over == 0 || this.currentFilter == 10) {
            this.noMoreArticle = true;
          }
          console.log(this.noMoreArticle)
          if(more) {
            this.articleList = [...this.articleList, ...data.info];
            this.loadingMoreData = false;
          }else {
            this.articleList = data.info || [];
            this.page = 0;
            this.noMoreArticle = (data.is_over == 0 || this.currentFilter == 10) ? true : false;
          }

          // 单独处理公开课
          if(this.currentFilter == 10) {
            this.articleList.forEach(item => {
              item.type = 10;
            })
          }

          cb && cb();
        })
      },
      // 筛选文章
      filterArticle(item) {
        this.currentFilter = item.id;
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true,
        });
        this.getArticle(0, () => {
          this.$toast.clear();
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          })
        })
      },
      searchArticle(type) {
        this.currentFilter = 0;
        if(type == 'clear') this.searchKey = '';
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true,
        });
        this.getArticle(0, () => {
          this.$toast.clear();
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          })
        })
      },
      toArticleDetail(item) {
        if(item.type == 10) {
          this.$router.push({name: 'publicClassDetail', params: {id: item.id}});
        }else {
          this.$router.push({name: 'ArticleDetail', params: {id: item.id}});
        }
      }
    },
    filters: {
      articleType(value) {
        switch(parseInt(value)) {
          case 1: return '在路上';break;
          case 2: return '经验弹';break;
          case 3: return '设计说';break;
          case 4: return '话局';break;
          case 5: return '设计室';break;
          case 6: return '资讯';break;
          case 7: return '名校记';break;
          case 8: return '奇想集';break;
          case 9: return '交互设计';break;
          case 10: return '公开课';break;
        }
      },
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY/MM/DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Articles/index.vue